import { useEffect, useState } from "react";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { PrintJson } from "./PrintJson";

interface Props {
    label?: string;
    idSelector: number;
    onChange: any;
    returnType?: "ID" | "Object";
    _disable?: boolean;
}

export const SelectGroupMemberAssigned = ({ label, idSelector, onChange, returnType = "ID", _disable }: Props) => {
    const [lista, setLista] = useState(_single.getGroupOnList());
    const [id, setID] = useState<number | null>(null);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
        }
    }, [idSelector, lista]);

    useEffect(() => {
        if (lista.length > 1) {
        } else if (lista.length === 1) {
            const singleItem = lista[0];
            const singleID = singleItem.DataBeanProperties.IDLn;
            setID(singleID);
            if (onChange) {
                onChange(returnType === "Object" ? singleItem.DataBeanProperties : singleID);
            }
        } else {
            toast.error("No se encuentra asignado a ningun grupo")
        }
    }, [lista])

    const setValue = (e: number | null) => {
        setID(e);
        if (onChange) {
            if (e === null) {
                onChange(null);
            } else {
                const selectedItem = lista.find(item => item.DataBeanProperties.IDLn === e);
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : e);
            }
        }
    };

    return (
        <>
            <label>{label ? label : "Grupos  de Trabajo Asignados"} </label>
            {lista.length === 1 ? (
                <span>
                    {lista[0].DataBeanProperties.IDLn} -{" "}
                    {lista[0].DataBeanProperties.FunctionalIDName}
                </span>
            ) : (
                <select
                    disabled={_disable}
                    className="form-select"
                    value={id !== null ? id : ""}
                    onChange={(e) => {
                        const value = e.target.value
                            ? parseInt(e.target.value)
                            : null;
                        setValue(value);
                    }}
                >
                    <option value="">...</option>
                    {lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.IDLn} >
                            {item.DataBeanProperties.IDLn} - {item.DataBeanProperties.Name}
                        </option>
                    ))}
                </select>
            )}
        </>
    );
};
